<template>
  <cs-basic>
    <template v-slot:header>
      <login-header app="sso" />
    </template>
    <template v-slot:content>
      <reset-password
        :tokenValid="tokenValid"
        :token="token"
        :fullName="fullName"
        :expiredPassword="expiredPassword"
      />
    </template>
    <template v-slot:footer>
      <login-footer />
    </template>
  </cs-basic>
</template>

<script>
import csBasic from '@/layouts/csBasic.vue'
import loginHeader from '@/components/header/loginHeader.vue'
import loginFooter from '@/components/loginFooter.vue'
import resetPassword from '@/components/forgotPassword/resetPassword.vue'

export default {
  components: {
    csBasic,
    loginHeader,
    loginFooter,
    resetPassword
  },
  data () {
    return {
      fullName: '',
      token: '',
      tokenValid: true,
      expiredPassword: this.$route.query.errorCode === 410
    }
  },
  async beforeCreate () {
    const token = this.$route.query.token

    if (!token) {
      this.$router.push({ name: 'NotFound' })
      return
    }

    const url = this.$store.state.global.baseUrl

    const result = await this.$http.post(
      `${url}/api/account/resolveactiontoken`,
      {
        token: token
      }
    )

    if (result.status !== 200) {
      this.$router.push({ name: 'NotFound' })
      return
    }

    const { action, infos } = result.data.data

    if (action === 'Error') {
      this.$router.push({ name: 'GetNewLink' })
      return
    }

    this.fullName = infos.Usuario
    this.token = token
    this.tokenValid = action === 'FirstLogin'
  }
}
</script>

<style></style>
